export default {
    title: '매일국어 T Activity Guide Collection',
};
